import SearchInput from 'app/components/SearchInput/SearchInput';

export default SearchInput;
